// extracted by mini-css-extract-plugin
export default {"multi-img-coll-info":"index_multi-img-coll-info__DCOB2"};